import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export default class ProductApi {
  context: AuthContextProps;

  constructor(context: AuthContextProps) {
    this.context = context;
  }

  getAll(lineId: number | null, type: number, medium?: number) {
    const uri =
      type === 10
        ? lineId !== null && lineId !== undefined
          ? "a/internet/NgnLine"
          : "n/internet/NgnLine"
        : lineId !== null && lineId !== undefined
        ? "a/internet/product"
        : "n/internet/product";

    let params = type !== 10 ? `?type=${type}` : "";

    if (lineId !== null && lineId !== undefined && type !== 10)
      params += `&lineId=${lineId}`;

    if (medium !== undefined)
      params += params ? `&medium=${medium}` : `?medium=${medium}`;

    return getData({
      uri,
      params,
      context: this.context,
    });
  }
}
